import { useMutation } from "react-query";
import http from "infra/http";

function useDuplicarArrecadacao() {
  return useMutation(
    `/v1/arrecadacao/arrecadacaoId/duplicar`,
    (id: string) => http.post(`/v1/arrecadacao/${id}/duplicar`),
    { retry: false }
  );
}

export default useDuplicarArrecadacao;
